import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import _ from 'lodash';
import { ISubmissionMetadata } from '@publishing-engine/domain/models';
import { generateValidationSchema } from 'src/utils/validation';
import { FormProvider, useForm } from 'react-hook-form';
import { ajvResolver } from '@hookform/resolvers/ajv';
import FundingGenericForm, { IFundingGenericValue } from './FundingGenericForm';
import { FormFieldFundingGeneric } from '@publishing-engine/domain/types/article';
import { hasDuplicateFundingBody } from 'src/utils/hasDuplicateFundingBody';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (value: IFundingGenericValue) => void;
  formField: FormFieldFundingGeneric;
  value?: ISubmissionMetadata['fundingGeneric'];
}

const FundingGenericUpdateModal: React.FC<Props> = props => {
  const { isOpen, onClose, formField, onSubmit } = props;

  const defaultValues = _.set(
    {} as IFundingGenericValue,
    formField.caseDataFields.main,
    props.value
  );

  const schema = generateValidationSchema({ FundingGeneric: formField });

  const methods = useForm({
    defaultValues,
    resolver: ajvResolver(schema)
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(data => {
            // const hasEmptyGrantNumber =
            //   data?.metadata?.fundingGeneric?.value.some(item =>
            //     item?.grantNumber.split(',').some(text => text?.trim() === '')
            //   );
            // if (!hasEmptyGrantNumber) {
            //   onClose();
            //   onSubmit(data);
            // }
            const duplicateIndex = hasDuplicateFundingBody(data);
            if (duplicateIndex !== -1) {
              methods.setError(
                `metadata.fundingGeneric.value.${duplicateIndex}.fundingBody`,
                { message: 'Duplicate Funding not allowed', type: 'manual' }
              );
              return;
            }
            onSubmit(data);
            onClose();
          })}
        >
          <Flex
            padding={8}
            gap={6}
            bgColor="surfacePrimaryFill"
            flexDirection="column"
            borderRadius="base"
          >
            <Flex maxHeight={700} overflow={'auto'}>
              <FundingGenericForm formField={formField} />
            </Flex>
            <Flex
              gap={2}
              justifyContent="flex-end"
              alignItems="center"
              alignSelf="stretch"
            >
              <Button
                variant="secondary"
                onClick={onClose}
                borderRadius="small"
              >
                Exit Without Saving
              </Button>
              <Button variant="primary" type="submit" borderRadius="small">
                Save Changes
              </Button>
            </Flex>
          </Flex>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default FundingGenericUpdateModal;
